module.exports = __webpack_public_path__ + "static/media/tokyo.4f351f7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tokyo.png
// module id = 865
// module chunks = 0